export default __webpack_public_path__ + "assets/d99b6c64079515dbffb4da40f702a1ad.jpeg";